import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">吃瓜热评</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/60 p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-[11px] text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/60">
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes.toLocaleString()}</span>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}